import Logger from './logger';

const log = new Logger();

/**
 * parseUtmCookie:
 * Parses the UTM cookie
 *
 * @param cookie
 * @param key
 * @returns {string}
 */
export default (cookie, key) => {
  log.debug({
    category: 'helpers',
    message: 'parseUTMCookie',
    data: {
      cookie,
      key
    }
  });

  if (!~cookie.indexOf(key)) {
    return 'none';
  }

  const keyIndex = cookie.indexOf(key);
  const pipeIndex = cookie.indexOf('|', keyIndex);

  return cookie
    .slice(keyIndex, pipeIndex)
    .split('=')[1]
    .replace(/(\(|\))/g, '');
};
